// extracted by mini-css-extract-plugin
export default {"pageTitle":"RoomDetail_pageTitle__1oh8H","titleText":"RoomDetail_titleText__teH2x","titleLogo":"RoomDetail_titleLogo__U3dXx"};